import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNavListpadIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M19.9635 4.5H8.28678C5.91926 4.5 4 6.63251 4 9.26309V22.2372C4 24.8678 5.91926 27.0003 8.28678 27.0003H19.9635C22.331 27.0003 24.2503 24.8678 24.2503 22.2372V9.26309C24.2503 6.63251 22.331 4.5 19.9635 4.5Z",
			fill: "#E2EDFF",
			stroke: "#354C8F",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 9.625,
			width: 9.00011,
			height: 5.62507,
			rx: 1.12501,
			fill: "#354C8F"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8.5,
			cy: 12.5,
			r: .5,
			fill: "#354C8F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 12.5H20",
			stroke: "#354C8F",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8.5,
			cy: 15.5,
			r: .5,
			fill: "#354C8F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 15.5H20",
			stroke: "#354C8F",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8.5,
			cy: 18.5,
			r: .5,
			fill: "#354C8F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 18.5H20",
			stroke: "#354C8F",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8.5,
			cy: 21.5,
			r: .5,
			fill: "#354C8F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 21.5H20",
			stroke: "#354C8F",
			strokeLinecap: "round"
		})
	]
});
export default SvgNavListpadIcon;
